import React from 'react';
import Icon from '../Icon';
import styled from 'styled-components';

const CheckBoxContainer = styled.div`
  ${(props) =>
    props.disabled
      ? `
    width: 17px;
    height: 17px;
    display: flex;
    justify-content: center;
    align-items: center;`
      : `
  background-color: white;
  border: 0.8px solid #1f2b37;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  border-radius: 3px;`}

  ${(props) =>
    props.checked &&
    `
    background-color: #e25d34;
    width: 17px;
    height: 17px;
    border: 0px;
    color: white;`}

  .checkbox-checkIcon {
    width: 16px;
    height: 16px;
  }

  .checkbox-img {
    width: 17px;
    height: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:hover {
    cursor: ${(props) => (props.disabled ? 'initial' : 'pointer')};
  }
`;

const Checkbox = ({ disabled, checked, onChange, styleDisabled, style }) =>
  !disabled ? (
    <CheckBoxContainer
      disabled={disabled}
      checked={checked}
      style={style}
      onClick={onChange}
    >
      {checked && (
        <div className="checkbox-img">
          <Icon icon={'check'} className="icon checkbox-checkIcon" />
        </div>
      )}
    </CheckBoxContainer>
  ) : (
    <CheckBoxContainer
      disabled={disabled}
      className="checkbox-img"
      style={styleDisabled}
    >
      <Icon className="icon" icon="close" />
    </CheckBoxContainer>
  );

export default Checkbox;
